<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;">
          <div>
            <div style="font-size:18px;padding-top: 20px;font-weight: bold;margin:10px;">
              快查成绩郑重承诺：</div>
            <div style="font-size:16px;padding-top: 10px;font-weight: bold;margin:10px;">
              平台侧不会泄露学生成绩,且对老师发布的成绩也不做任何加工和计算,也即老师发什么系统显示什么。请广大老师监督和反馈。反馈和投诉微信:wx34424698</div>
          </div>

          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;color:red;">
            本软件是免费软件，发成绩和查成绩均免费，无任何限制。</div>

          <div style="font-size:18px;padding-top: 10px;font-weight: bold;margin:10px;">
            由于软件升级很快,无法及时更新操作视频,请入群观看操作视频和获得支持服务.</div>

          <div style="font-size:16px;padding-top: 20px;margin:10px;">
            <div style="width:40%;display: flex;justify-content: center;flex-direction: column;">
              <div style="font-size: 20px;font-weight: bold;text-align: center;">微信扫码免费加入客服群</div>
              <div style="text-align: center;">
                <img src="/score/images/kc_teacher_group.png" style="width:300px;height:300px;" />

              </div>
              <div style="font-size: 20px;font-weight: bold;text-align: center;">微信扫码入群观看最新视频</div>
            </div>
          </div>

          <!--          <div class="rowStyle">
            <div style="font-size:16px;padding-top: 20px;margin-left: 20px;"><span
                style="">注意事项1.</span>要导入的Excel格式的成绩单必须备两个条件，一是表格中有<span
                style="color: red;">姓名</span>,二是有<span
                style="color: red;">学号</span>。学号是用于查询成绩的密码，可以是任意数据，如数字、字母等，为了方便输入建议是长度超过4位的数字。</div>
          </div> -->

          <!--          <div class="rowStyle">
            <div style="font-size:16px;padding-top: 20px;margin-left: 20px;"><span
                style="">注意事项2.</span>1个手机默认只能查询1个学生成绩。如果是很保密的成绩,请将学号私下告知学生让其保密，防止其他学生解锁查询；如果不重要的成绩，可以将姓名和学号的对应关系发到家长群中，减轻老师私发学号的工作量。
            </div>
          </div> -->
          <div style="color:red;font-size: 16px;font-weight: bold;margin-top: 10px;">以下视频可能较旧,请及时扫描上面的二维码入群观看最新视频</div>
          <div style="margin-top: 10px;padding-bottom: 20px;">
            <div style="font-size: 14px;margin-top: 10px;"><a href="/score/help/成绩单下发.mp4"
                target="_blank">点我学习“如何发布成绩”</a></div>

            <div style="font-size: 14px;margin-top: 10px;"><a href="/score/help/花名册管理.mp4"
                target="_blank">点我学习“如何管理用于手机端录入成绩所用的花名册”</a></div>

            <div style="font-size: 14px;margin-top: 10px;"><a href="/score/help/快速合并成绩单.mp4"
                target="_blank">点我学习“如何合将多个学科的成绩合并到一个成绩单中”</a></div>
          </div>

          <!-- <div style="font-size: 18px;margin-top: 20px;">
            <div style="font-weight: bold;">用接龙、xx文档收资料(行程码、健康码信息、基本信息等)正毁坏着您的名誉！</div>
            <div style="font-size: 16px;margin-top: 10px;">
              您还在用腾讯文档、金山文档、接龙等软件收资料?您不知道<span style="color:red;">家长对您多咬牙切齿</span>，手机填写您不知道有多痛苦不说还把自己家里的隐私信息在群里漏了个底朝天！不知多少家长边填嘴里边飚脏话！！
            </div>
            <div style="font-size: 16px;margin-top: 10px;">
              您试试<span style="color:red;">多人填表微信小程序</span>吧！保护隐私、家长填写简单，数据格式还相当规范，一键导出Excel文档。
            </div>
            <div style="font-size: 16px;margin-top: 10px;margin-bottom: 20px;text-align: center;">
              <div style="font-weight: bold;">立即用微信扫码体验</div>
              <div><img src="/score/images/duoren_mp.jpg" style="width: 200px;height: 200px;"/></div>
             <div style="font-weight: bold;">多人填表用多人填表</div>
             <div style="font-weight: bold;">拒绝泄露个人隐私,只因您也是家长！</div>
            </div>
          </div> -->

        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {

    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/read_me.vue